export function isNullish(value: any): value is null | undefined {
  return value === null || value === undefined
}

export function isFalsy(value: any): value is null | undefined | false {
  return isNullish(value) || value === false
}

export function toNumber(value: any) {
  const parsedNumber = parseFloat(value)

  return isNaN(parsedNumber) ? undefined : parsedNumber
}

export function toString(value: any) {
  return typeof value === 'string' ? value : undefined
}

export function toEnum<T extends string>(value: any, enums: readonly T[]) {
  return enums.includes(value) ? (value as T) : undefined
}

export function toBoolean(value: any) {
  if (value === null || value === undefined) {
    return
  }

  return !!value
}

export function toArray<T>(
  value: any,
  mapFunction: (el: any) => T = (el) => el
) {
  if (Array.isArray(value)) {
    return value
      .map((el: any) => mapFunction(el))
      .filter((el): el is NonNullable<T> => el !== undefined && el !== null)
  }
}

export function toNumberArray(value: any) {
  return toArray(value, toNumber)
}

export function toEnumArray<T extends string>(value: any, enums: T[]) {
  return toArray(value, (el) => toEnum(el, enums))
}
